// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper__bX4ke","content":"content__3WCLc","heading":"heading__1xQvv","text":"text__1SDmJ","button":"button__3FFT2"};